export default __webpack_public_path__ + "media/components/Courses/Show/Images/disciplines/5-974a4e6f51a7a28b743cd7bf0759fa40.svg";